import React from "react";

const Grupo2 = ({datos,handleChange,eliminarFila}) => {

    return (

        <div>

            {/* TABLA */}

            <div className="table-responsive">

                <table className="table align-middle">

                    <thead className="table-secondary">

                        <tr>

                            <th>Departamento</th>
                            <th>Municipio</th>
                            <th>Unidades Territoriales</th>
                            <th style={{ minWidth: "300px" }}>Descripción de la iniciativa</th>
                            <th style={{ width: "140px" }}>Avance Enero</th>
                            <th style={{ width: "150px" }}>Subcontratado</th>
                            <th style={{ width: "80px" }}>Acción</th>

                        </tr>

                    </thead>

                    <tbody>

                        {

                            datos.length === 0 &&

                            <tr>

                                <td colSpan={7} className="text-center">No hay registros. Presione "Agregar fila" para comenzar.</td>

                            </tr>

                        }

                        {

                            datos.map((item, index) => (

                                <tr key={index}>

                                    <td>

                                        <input
                                            className="form-control"
                                            placeholder="Departamento"
                                            value={item.departamento || ""}
                                            onChange={(e) =>
                                                handleChange(
                                                    index,
                                                    "departamento",
                                                    e.target.value
                                                )
                                            }
                                        />

                                    </td>

                                    <td>

                                        <input
                                            className="form-control"
                                            placeholder="Municipio"
                                            value={item.municipio || ""}
                                            onChange={(e) =>
                                                handleChange(
                                                    index,
                                                    "municipio",
                                                    e.target.value
                                                )
                                            }
                                        />

                                    </td>

                                    <td>

                                        <input
                                            className="form-control"
                                            placeholder="Unidad Territorial"
                                            value={item.unidades_territoriales || ""}
                                            onChange={(e) =>
                                                handleChange(
                                                    index,
                                                    "unidades_territoriales",
                                                    e.target.value
                                                )
                                            }
                                        />

                                    </td>

                                    <td>

                                        <textarea
                                            className="form-control"
                                            rows={3}
                                            placeholder="Descripción..."
                                            value={item.descripcion_iniciativa || ""}
                                            onChange={(e) =>
                                                handleChange(
                                                    index,
                                                    "descripcion_iniciativa",
                                                    e.target.value
                                                )
                                            }
                                        />

                                    </td>

                                    <td>
                                      <div className="input-group">

                                        <input
                                            type="number"
                                            className="form-control"
                                            min="0"
                                            max="100"
                                            step="1"
                                            value={item.avance_enero ?? ""}
                                            onChange={(e) =>
                                                handleChange(
                                                    index,
                                                    "avance_enero",
                                                    e.target.value
                                                )
                                            }
                                        />

                                        <span className="input-group-text">%</span>

                                    </div>

                                    </td>

                                   <td>

                                        <input
                                            className="form-control"
                                            placeholder="Subcontratado"
                                            value={item.subcontratado || ""}
                                            onChange={(e) =>
                                                handleChange(
                                                    index,
                                                    "subcontratado",
                                                    e.target.value
                                                )
                                            }
                                        />

                                    </td>

                                    <td className="text-center">

                                        <button className="btn btn-sm btn-danger" onClick={() =>eliminarFila(index)}>

                                            <i className="bi bi-trash"></i>

                                        </button>

                                    </td>

                                </tr>

                            ))

                        }

                    </tbody>

                </table>

            </div>

        </div>

    );

};

export default Grupo2;